<div class="div_employees">
  <div class="pos-title-header">
    <label class="lbl_top">{{'EMPLOYEES.ADD_EMPLOYEE' | translate}}</label>
    <button class="create_btn" (click)="addEmployee()">
      <span class="hide_mobile">{{'CREATE' | translate}}</span>
      <i class="show_mobile pi pi-plus-circle"></i>
    </button>
  </div>
  <div class="pos-description-header">
    <label class="w-100 text-start">{{'EMPLOYEES.ADD_EMPLOYEES_HERE' | translate}}.</label>
  </div>
  <div class="employees_container">
    <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
    <div *ngFor="let employee of listAllEmployees" class="employee_card">
      <p-card styleClass="p-card-shadow">
        <ng-template pTemplate="header">
          <div [style.background-image]="'url(' + determineImageForEmployee(employee.pictureUrl) +')'" class="employee_card_img">
            <div class="emp_dropdown_helper" #icon (click)="menu.toggle($event)"></div>
            <i class="pi pi-ellipsis-v spam-menu" (click)="icon.click()"  style="text-shadow: 1px 1px var(--soc-neutral-10);"></i>
            <p-menu #menu class="edit-menu header-menu" [popup]="true" [model]="items[employee.id]"></p-menu>
          </div>
        </ng-template>
        <ng-template pTemplate="body">
          <div class="d-flex flex-row me-3 items_center">
            <img class="employee_picture_list"
                 [src]="employee.pictureUrl ? employee.pictureUrl : imagePath "
                 alt="profile-picture">
            <div class="employee_info" title="{{employee.firstName + ' ' + employee.lastName}}">
              <h5 class="title"><span>{{employee.firstName}}
                            </span><span>{{employee.lastName}}</span></h5>
              <div class="employee_role">
                <span> {{'EMPLOYEES.' + EmployeeRoleEnum[employee.venueEmployeeTypeId].toUpperCase() | translate}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </p-card>
    </div>
  </div>
</div>
